(function () {
  var FADE_MS = 250;

  function initEventGallery(gallery) {
    var section = gallery.closest('.article-event-1925');
    var lightbox = section ? section.querySelector('[data-event-lightbox]') : null;
    if (!lightbox) return;

    var triggers = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-event-lightbox-src]')
    );
    if (!triggers.length) return;

    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    var imageEl = lightbox.querySelector('[data-event-lightbox-img]');
    var prevBtn = lightbox.querySelector('[data-event-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-event-lightbox-next]');
    var closeEls = lightbox.querySelectorAll('[data-event-lightbox-close]');
    var currentIndex = 0;
    var lastFocus = null;
    var closeTimer = null;
    var swapping = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function isOpen() {
      return lightbox.classList.contains('is-open');
    }

    function setImage(index) {
      currentIndex = (index + triggers.length) % triggers.length;
      var src = triggers[currentIndex].getAttribute('data-event-lightbox-src');
      var alt = triggers[currentIndex].getAttribute('data-event-lightbox-alt') || '';
      if (imageEl) {
        imageEl.src = src;
        imageEl.alt = alt;
      }
      if (prevBtn) prevBtn.hidden = triggers.length <= 1;
      if (nextBtn) nextBtn.hidden = triggers.length <= 1;
    }

    function swapImage(index) {
      if (!imageEl || !isOpen()) {
        setImage(index);
        return;
      }

      var newIndex = (index + triggers.length) % triggers.length;
      if (newIndex === currentIndex || swapping) return;

      var src = triggers[newIndex].getAttribute('data-event-lightbox-src');
      var alt = triggers[newIndex].getAttribute('data-event-lightbox-alt') || '';

      if (reducedMotion) {
        setImage(newIndex);
        return;
      }

      swapping = true;
      var fadeOutDone = false;
      var imageReady = false;

      function revealNextImage() {
        if (!fadeOutDone || !imageReady) return;

        imageEl.src = src;
        imageEl.alt = alt;
        currentIndex = newIndex;
        void imageEl.offsetWidth;
        imageEl.classList.remove('is-swapping');
        swapping = false;
      }

      imageEl.classList.add('is-swapping');

      window.setTimeout(function () {
        fadeOutDone = true;
        revealNextImage();
      }, FADE_MS);

      var preload = new Image();
      preload.onload = function () {
        imageReady = true;
        revealNextImage();
      };
      preload.onerror = function () {
        imageReady = true;
        revealNextImage();
      };
      preload.src = src;
    }

    function onKeydown(event) {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        swapImage(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        swapImage(currentIndex + 1);
      }
    }

    function open(index) {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      swapping = false;
      lastFocus = document.activeElement;
      setImage(index);
      if (imageEl) imageEl.classList.remove('is-swapping');
      lightbox.removeAttribute('hidden');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('article-event-1925-lightbox-open');
      document.addEventListener('keydown', onKeydown);

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          lightbox.classList.add('is-open');
        });
      });

      var closeBtn = lightbox.querySelector('.article-event-1925-lightbox__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen()) return;

      swapping = false;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('article-event-1925-lightbox-open');
      document.removeEventListener('keydown', onKeydown);

      if (imageEl) imageEl.classList.remove('is-swapping');

      var closeDelay = reducedMotion ? 0 : 800;
      closeTimer = window.setTimeout(function () {
        lightbox.setAttribute('hidden', '');
        if (imageEl) imageEl.removeAttribute('src');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        closeTimer = null;
      }, closeDelay);

      if (reducedMotion) {
        window.clearTimeout(closeTimer);
        lightbox.setAttribute('hidden', '');
        if (imageEl) imageEl.removeAttribute('src');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        closeTimer = null;
      }
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        open(index);
      });
    });

    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        swapImage(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        swapImage(currentIndex + 1);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-event-gallery]').forEach(initEventGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
